import { fetchListCatalogs } from 'common/api/documentCatalog';
import {
    PRODUCT_DOCUMENTS_CATEGORY,
    INSURANCE_DOCUMENTS_TYPE,
} from 'common/constants';

import {
    FETCH_INSURANCE_DOCUMENTS,
    FETCH_INSURANCE_DOCUMENTS_FAILURE,
    FETCH_INSURANCE_DOCUMENTS_SUCCESS,
} from '../../actionTypes';
import { creditFileActions } from '../../reducer';

export default () => (dispatch) => {
    dispatch(creditFileActions[FETCH_INSURANCE_DOCUMENTS]());

    fetchListCatalogs()
        .then((response) => {
            const dataFiltered = response.data.data.filter(
                (item) =>
                    item.category === PRODUCT_DOCUMENTS_CATEGORY &&
                    item.type === INSURANCE_DOCUMENTS_TYPE,
            );
            dispatch(
                creditFileActions[FETCH_INSURANCE_DOCUMENTS_SUCCESS](
                    dataFiltered,
                ),
            );
        })
        .catch((error) =>
            dispatch(
                creditFileActions[FETCH_INSURANCE_DOCUMENTS_FAILURE](
                    error?.response?.data?.errors,
                ),
            ),
        );
};
